<template>
  <div style="height: 100%">
    <v-tooltip bottom v-if="sequence == 0">
      <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" v-if="sequence == 0" class="white--text font-weight-regular">{{title}}</span>
      </template>
    <span>{{ $t("agenda.hTopicCategoryTooltip") }}</span>
  </v-tooltip>
    <v-btn v-if="sequence == 0" icon x-small class="mx-2" @click="openManual()">
      <v-icon color="#ffffff"
        >mdi-alert-circle-outline</v-icon
      >
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "StackedColumnTemplate",
  props: {
    title: {
      type: String,
      default: null,
    },
    sequence: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
    }
  },
  methods: {
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: '/usermanual',
        query: { content: this.$i18n.locale == "en" ? "Manual_E_Topic Category.pdf" : "Meeting.Structure.Sample.pdf", id: 'TopicCategory' },
      });
      let popup;
      if (routeData && (typeof this.manualWindow === "undefined" ||
        this.manualWindow.closed || this.manualClick === 1)) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      }
      else {
        this.manualWindow.focus();
      }
    },
  }
};
</script>
